/**
 * Legacy ReservationApi module — preserved as an empty AngularJS module so the
 * dependency `acme.common.service.reservation` declared by api.service.js
 * still resolves.
 *
 * The legacy provider/setEndpoint pattern is gone; the new Angular 18
 * implementation injects directly into the facade as
 * `apiService.reservations`. Source:
 *   apps/b2b-frontend/app/core/api/reservations/reservations-api.service.ts
 */
angular.module("acme.common.service.reservation", ["acme.common.service.utils"]);
